import { Select, Slider } from "antd";

import { ThreeDViewerOptionT } from "models";

import { ThreeDVOptionItem, ThreeDVOptionsWrapper } from "./ThreeDVOptionsLayout";

function ThreeDVSettingsOptions(props: ThreeDViewerOptionT): JSX.Element {
  return (
    <ThreeDVOptionsWrapper>
      <ThreeDVOptionItem>
        <label>Scale Z</label>
        <Slider
          className="action"
          value={props.scaleZ}
          min={1}
          max={40}
          onChange={(e) => {
            props.onOptionChange && props.onOptionChange({ scaleZ: e }, false);
          }}
        />
      </ThreeDVOptionItem>
      <ThreeDVOptionItem>
        <label>Line Width</label>
        <Slider
          className="action"
          value={props.lineWidth}
          min={1}
          max={10}
          onChange={(e) => {
            props.onOptionChange && props.onOptionChange({ lineWidth: e }, false);
          }}
        />
      </ThreeDVOptionItem>
      <ThreeDVOptionItem>
        <label>Surfaces Source</label>
        <Select
          size="small"
          value={props.modelSource}
          options={props.modelSources}
          onChange={(e) => {
            props.onOptionChange && props.onOptionChange({ modelSource: e }, true);
          }}
        />
      </ThreeDVOptionItem>
    </ThreeDVOptionsWrapper>
  );
}

export default ThreeDVSettingsOptions;
